/**
 * Entry application component used to compose providers and render Routes.
 * */

import { Amplify, Auth } from "aws-amplify";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import { Routes } from "../app/Routes";
import { AWSConfig, NAME } from "./aws-exports";
import './../../src/app/modules/coinWrap/Utils/i18n/i18n.js';

export default function App({ store, persistor, basename }) {
  Amplify.configure(AWSConfig);
  Auth.configure();
  console.log('enviroment name', NAME);
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <MaterialThemeProvider>
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              {/* <I18nProvider> */}
              {/* Render routes with provided `Layout`. */}
              <Routes />
              {/* </I18nProvider> */}
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
